export default __webpack_public_path__ + "static/media/014-n.38253928.svg";